module.exports = __webpack_public_path__ + "static/img/lbbg3.8a73c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbbg3.png
// module id = 2FrI
// module chunks = 0